import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTasks } from '../hooks/useTasks';
import { TaskList } from '../components/TaskList';

export function TasksPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const { data, isLoading } = useTasks({ page });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">Tasks</h2>
        <button onClick={() => navigate('/tasks/new')} className="btn btn-primary text-sm">
          New Task
        </button>
      </div>

      {isLoading ? (
        <div className="text-center py-8 text-gray-500">Loading tasks...</div>
      ) : (
        <TaskList sessions={data?.sessions ?? []} />
      )}

      {data && data.total > 20 && (
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
            className="btn btn-outline text-sm"
          >
            Previous
          </button>
          <span className="text-sm text-gray-600">Page {page}</span>
          <button
            onClick={() => setPage((p) => p + 1)}
            disabled={(data.sessions?.length ?? 0) < 20}
            className="btn btn-outline text-sm"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
